import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';
import { IYogiyoStore } from 'interfaces/store';

export type TRestaurantInitialState = IYogiyoStore | {};

const initialState: TRestaurantInitialState = {};

export const restaurantSelector = (state: RootState) =>
  state.restaurant as IYogiyoStore;

export const popupSlice = createSlice({
  name: 'restaurant',
  initialState,
  reducers: {
    setRestaurant: (state, action) => {
      state = action.payload;
      return state;
    },
    setIsAllHotdeal: (state, action) => {
      state = {
        ...state,
        isAllHotdeal: action.payload.isAllHotdeal,
      };

      return state;
    },
  },
});

export const { setRestaurant, setIsAllHotdeal } = popupSlice.actions;

export default popupSlice.reducer;
